import { call, put, takeLatest } from "redux-saga/effects";
import * as actionTypes from "../ActionTypes";
import {
  saveProgramSuccess,
  saveProgramFailure,
  updateProgramSuccess,
  updateProgramFailure,
  deleteProgramSuccess,
  deleteProgramFailure,
} from "./programActions";
import { saveProgram, updateProgram, deleteProgram } from "./program";

// ✅ Save Program Saga
function* saveProgramSaga(action) {
  try {

    // ✅ FIX: Extract correctly
    const { apiPayloadRequest } = action.payload;

    // Call API
    const response = yield call(saveProgram, apiPayloadRequest);

    if (response?.type === 1) {
      yield put(saveProgramSuccess(response.data));

      // ✅ Callback with all data, including programObjId
      if (typeof action.callback === "function") {
        action.callback({
          type: 1,
          data: {
            ...response.data,
            programObjId:
              response.programObjId ||
              response?.data?.programObjId ||
              null,
            message: response.message,
          },
        });
      }
    } else {
      const error = response?.error || response?.message || "Save failed";
      yield put(saveProgramFailure(error));
      if (typeof action.callback === "function") {
        action.callback({ type: 0, error });
      }
    }
  } catch (error) {
        yield put(saveProgramFailure(error.message));
    if (typeof action.callback === "function") {
      action.callback({ type: 0, error: error.message });
    }
  }
}

// ✅ Update Program
function* updateProgramSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload;
    const data = yield call(updateProgram, apiPayloadRequest);

    if (data?.type === 1) {
      yield put(updateProgramSuccess(data.data || apiPayloadRequest));
      if (typeof action.callback === "function")
        action.callback({ type: 1, data: data.data });
    } else {
      yield put(updateProgramFailure(data?.error || "Update failed"));
      if (typeof action.callback === "function")
        action.callback({ type: 0, error: data?.error });
    }
  } catch (error) {
    yield put(updateProgramFailure(error.message));
    if (typeof action.callback === "function")
      action.callback({ type: 0, error: error.message });
  }
}

// ✅ Delete Program
function* deleteProgramSaga(action) {
  try {
    const { _id, programObjId } = action.payload;

    // Call API
    const res = yield call(deleteProgram, { _id, programObjId });

    // Always prepare a safe callback object
    const callbackRes = {
      type: res?.type === 1 ? 1 : 0,
      programObjId: programObjId || null,
      message: res?.message || (res?.type === 1 ? "Program deleted successfully!" : undefined),
      error: res?.error || (res?.type === 0 ? "Delete failed" : undefined),
    };

    if (res?.type === 1) {
      // Remove from state
      yield put(deleteProgramSuccess({ programObjId }));
    } else {
      yield put(deleteProgramFailure(callbackRes.error));
    }

    // Always call the callback safely
    if (typeof action.callback === "function") action.callback(callbackRes);

  } catch (error) {
    const callbackRes = {
      type: 0,
      programObjId: action.payload?.programObjId || null,
      error: error?.message || "Delete failed",
    };
    yield put(deleteProgramFailure(callbackRes.error));
    if (typeof action.callback === "function") action.callback(callbackRes);
  }
}






export default function* programWatcherSaga() {
  yield takeLatest(actionTypes.SAVE_PROGRAM_REQUEST, saveProgramSaga);
  yield takeLatest(actionTypes.UPDATE_PROGRAM_REQUEST, updateProgramSaga);
  yield takeLatest(actionTypes.DELETE_PROGRAM_REQUEST, deleteProgramSaga);
}
